import React from "react";
import "../styles/ClientTestimonial.css";
import { testimonials } from "../data/siteData";

function TestimonialCard({ testimonial }) {
  return (
    <article className="tp-testimonial__card">
      <span className="tp-testimonial__quote-mark">“</span>
      <p className="tp-testimonial__quote">{testimonial.quote}</p>
      <div className="tp-testimonial__author">
        <span className="tp-testimonial__name">{testimonial.name}</span>
        <span className="tp-testimonial__country">{testimonial.location}</span>
        <span
          className="tp-testimonial__stars"
          aria-label={`${testimonial.rating} out of 5 stars`}
        >
          {"★".repeat(testimonial.rating)}
          {"☆".repeat(5 - testimonial.rating)}
        </span>
      </div>
    </article>
  );
}

function TestimonialRow({ items, reverse = false }) {
  const duplicatedItems = [...items, ...items];

  return (
    <div
      className={`tp-testimonial__track-wrapper ${
        reverse ? "tp-testimonial__track-wrapper--reverse" : ""
      }`}
    >
      <div
        className={`tp-testimonial__track ${
          reverse ? "tp-testimonial__track--reverse" : ""
        }`}
      >
        {duplicatedItems.map((testimonial, index) => (
          <TestimonialCard
            key={`${testimonial.name}-${index}`}
            testimonial={testimonial}
          />
        ))}
      </div>
    </div>
  );
}

export default function ClientTestimonial({
  eyebrow = "Client Words",
  title = "What Our Partners Say",
  description = "Long-term relationships built on consistency, transparency, and craft.",
}) {
  return (
    <section className="tp-testimonial">
      <div className="tp-testimonial__container">
        <div className="tp-testimonial__header">
          <div className="tp-testimonial__heading">
            <span className="tp-testimonial__eyebrow">
              {testimonials.eyebrow}
            </span>
            <h2 className="tp-testimonial__title">{testimonials.heading}</h2>
          </div>

          <p className="tp-testimonial__description">{testimonials.sub}</p>
        </div>

        <div className="tp-testimonial__rows">
          <TestimonialRow items={testimonials.items.slice(0, 5)} />
          <TestimonialRow items={testimonials.items.slice(4, 9)} reverse />
        </div>

        {/* <a href="/client-words" className="tp-testimonial__link">
          <span>{testimonials.seeAllLabel}</span>
          <span>→</span>
        </a> */}
      </div>
    </section>
  );
}
